module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"title":"Add Constant Contact contacts to Keap","nestedModalTitle":"Import from Constant Contact","divider":"or","csvImport":{"upload":"Upload a spreadsheet of contacts"},"helpText":{"help1":"Have questions? Visit our ","helpLink":"Help Center"}}}')
  delete Component.options._Ctor
}
